import SpaceSizes from '../../../theme/foundations/spacing/SpaceSizes';

export const boxContainerStyled = {
  '&.MuiBox-root': {
    paddingTop: { xs: SpaceSizes.mdPlus, sm: SpaceSizes.lgPlus },
    paddingBottom: SpaceSizes.mdPlus,
    marginTop: SpaceSizes.none,
  },
};
